import { useQuery } from '@apollo/client';
import { useRouter } from '@application/utils';
import { graphql } from '@gql/gql';
import type { BreedComparatorGetBreedsQuery, BreedDetailsInfoFragment } from '@gql/graphql';
import { sortBy } from 'lodash/fp';

export const BREED_COMPARATOR_GET_BREEDS = graphql(`
  query BreedComparatorGetBreeds($where: DogBreedWhereInput) {
    findManyDogBreed(where: $where) {
      ...BreedDetailsInfo
    }
  }
`);

export const useGetBreeds = (breedNames: string[]) => {
  const { language } = useRouter();

  const { data, error, loading } = useQuery(BREED_COMPARATOR_GET_BREEDS, {
    variables: {
      where: {
        name: { in: breedNames },
        translations: { some: { language: { equals: language } } },
      },
    },
    skip: breedNames.length < 2,
    ssr: false,
  });

  return {
    breeds: sortBy(
      (b: BreedDetailsInfoFragment) => breedNames.indexOf(b.baseBreedName ?? b.name),
      data?.findManyDogBreed ?? [],
    ) as BreedComparatorGetBreedsQuery['findManyDogBreed'],
  };
};
